import { render, staticRenderFns } from "./asaas.vue?vue&type=template&id=4413bfb8&scoped=true"
import script from "./asaas.vue?vue&type=script&lang=js"
export * from "./asaas.vue?vue&type=script&lang=js"
import style0 from "./asaas.vue?vue&type=style&index=0&id=4413bfb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4413bfb8",
  null
  
)

export default component.exports